module.exports = __webpack_public_path__ + "img/motor_no53.626b3def.jpg";